import {useTranslation} from "react-i18next"
import {useLocation} from "react-router-dom"
import {useNwDashboardContext} from "../../reactContext/contextCustomHooks/useNwDashboardContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import {useLexiconsContext}  from "../../reactContext/contextCustomHooks/useLexiconsContext"
import {useStProjectsContext} from "../../reactContext/contextCustomHooks/useStProjectsContext"
import {useStWorkflowContext} from "../../reactContext/contextCustomHooks/useStWorkflowContext"
import {useEcpProjectsContext} from "../../reactContext/contextCustomHooks/useEcpProjectsContext"
import {useEcpWorkflowContext} from "../../reactContext/contextCustomHooks/useEcpWorkflowContext"

export default function PopupOverlay() {
    const {t} = useTranslation()
    let location = useLocation()
    const {teamContext} = useTeamContext()
    const {nwDashboardContext} = useNwDashboardContext()
    const {lexiconsContext} = useLexiconsContext()
    const {stProjectsContext} = useStProjectsContext()
    const {stWorkflowContext} = useStWorkflowContext()
    const {ecpProjectsContext} = useEcpProjectsContext()
    const {ecpWorkflowContext} = useEcpWorkflowContext()
    const locationPathname = location.pathname.split("/")[1]
    return (
        <>
        {((lexiconsContext.isModal && (locationPathname === "lexicons" || locationPathname === "st"))
        || ((nwDashboardContext.isConfirmationModal.modal || nwDashboardContext.isModal) && locationPathname === "neurowide-dashboard")
        || ((stProjectsContext.isModal || stProjectsContext.isConfirmationModal.modal) && locationPathname === "st")
        || ((ecpProjectsContext.isModal || ecpProjectsContext.isConfirmationModal.modal) && locationPathname === "ecp")
        || (lexiconsContext.isConfirmationModal.modal && locationPathname === "lexicons")
        || (teamContext.isConfirmationModal.modal && locationPathname === "team-management")
        || (stWorkflowContext.isConfirmationModal.modal && locationPathname === "st")
        || (ecpWorkflowContext.isConfirmationModal.modal && locationPathname === "ecp")
        || (ecpWorkflowContext.isGlossaryModal.modal && locationPathname === "ecp")) &&
            <><div className="popup-overlay force-display"></div></>
        }
        <div className="screen-limit-overlay">
            <h2>{t("Neurowide.studio requires a larger screen, please use a desktop browser.")}</h2>
        </div>
        </>
    )
}